import React from 'react'
import {  Box } from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';

// const firstRow = {
//     id: 1,
//     Part_Code:"",
//     Part_Descrption: "",
//     Qty: "",
//     Cost_Rate: "",
//     Markup: "",
//     Trade_Rate: "",
//     Disc: "",
//     Disc_Amt: "",
//     Taxable_Amt: "",
//     Vat: "",
//     Vat_Amount: "",
//     Total_Amount: "",
// }

// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />  
  );}

function WorkVerificationParts() {
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false },
    { field: 'Part_Code', headerName: 'Part Code', editable: false, sortable: false, flex: 1.5, minWidth: 100 },
    { field: 'Part_Descrption', headerName: 'Part Descrption', editable: false, sortable: false, flex: 1.5, minWidth: 100 },
    { field: 'Qty', headerName: 'Qty', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Cost_Rate', headerName: 'Cost Rate', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Markup', headerName: 'Markup', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Trade_Rate', headerName: 'Trade Rate', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Disc', headerName: 'Disc', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Disc_Amt', headerName: 'Disc Amt', editable: false, sortable: false ,flex: 1, minWidth: 100},
    { field: 'Taxable_Amt', headerName: 'Taxable Amt', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Vat', headerName: 'Vat%', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Vat_Amount', headerName: 'Vat_Amount', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Total_Amount', headerName: 'Total_Amount', editable: false, sortable: false, flex: 1, minWidth: 100 },
    ]; 
    
    const rows = [
    { id: '1', Part_Code:'', Part_Descrption:'', Qty:'', Cost_Rate:'', Markup:'', Trade_Rate:'', Disc:'', Disc_Amt:'', Taxable_Amt:'', Vat:'', Vat_Amount:'', Total_Amount:'' },
    { id: '2', Part_Code:'', Part_Descrption:'', Qty:'', Cost_Rate:'', Markup:'', Trade_Rate:'', Disc:'', Disc_Amt:'', Taxable_Amt:'', Vat:'', Vat_Amount:'', Total_Amount:'' },
    { id: '3', Part_Code:'', Part_Descrption:'', Qty:'', Cost_Rate:'', Markup:'', Trade_Rate:'', Disc:'', Disc_Amt:'', Taxable_Amt:'', Vat:'', Vat_Amount:'', Total_Amount:'' },
    { id: '4', Part_Code:'', Part_Descrption:'', Qty:'', Cost_Rate:'', Markup:'', Trade_Rate:'', Disc:'', Disc_Amt:'', Taxable_Amt:'', Vat:'', Vat_Amount:'', Total_Amount:'' },
    { id: '5', Part_Code:'', Part_Descrption:'', Qty:'', Cost_Rate:'', Markup:'', Trade_Rate:'', Disc:'', Disc_Amt:'', Taxable_Amt:'', Vat:'', Vat_Amount:'', Total_Amount:'' },
    
    
    ];                              
    return (
      <form>
        <Box mt={1}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default WorkVerificationParts